import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateCampaignRequest } from '../types';
import { Mc3Client } from './client';
import { campaignQueryKeys } from './queryKeys';

export function useCreateCampaigns() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: CreateCampaignRequest) =>
      Mc3Client.post('api/campaigns', { json: request }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: campaignQueryKeys.all() });
    },
  });
}
